import { useContext, useEffect, useState } from "react";
import CampaignContext from "../../../../contexts/CampaignContext";
import UserContext from "../../../../contexts/UserContext";
import {
  setTransactionFilters,
  transactionFiltersState,
} from "../../../../redux/entriesSlice";
import restService from "../../../../restService";
import { handleRewardTypes } from "../../../../utilities";
import { DatePicker } from "../../../components";
import Dropdown from "../../../components/Dropdown";

import { useDispatch, useSelector } from "react-redux";
import ExportReportButton from "../../../components/export-modal";

export default function Filters({
  setPage,
  handleSearch,
  isGettingDataToExport,
  entriesToExport,
  msisdn,
  setMsisdn,
  setTransactionResult,
  transactionResult,
  exportEntries,
}) {
  const dispatch = useDispatch();
  const [campaign] = useContext(CampaignContext);
  const [user] = useContext(UserContext);

  const transactionsFilters = useSelector(transactionFiltersState);
  const dateRange = transactionsFilters?.dateRange;
  const station = transactionsFilters?.station;
  const entryStatus = transactionsFilters?.entryStatus;
  const rewardType = transactionsFilters?.rewardType;
  const network = transactionsFilters?.network;
  const selectedChannel = transactionsFilters?.selectedChannel;

  function updateTransactionFilters(key, data) {
    const newTransactionFilters = {
      ...transactionsFilters,
      [key]: data,
    };

    dispatch(setTransactionFilters(newTransactionFilters));
  }

  const [rewardId, setRewardId] = useState("");
  const [rewards, setRewards] = useState([]);
  const [stations, setStations] = useState([]);
  const [actionMenu, setActionMenu] = useState("");
  const Network = ["MTNGH", "OT", "MYBUZZ", "ZAIN_RANCARD", "GLO_GHANA"];
  const mobileNet = ["MTN", "VODAFONE", "TIGO", "AIRTEL", "GLO"];
  const statuses = [
    { id: "REDEEMED", value: "Redeemed" },
    { id: "PENDING", value: "Pending" },
    { id: "WIN_IGNORE", value: "Win Ignore" },
    { id: "FAILED", value: "Failed" },
    { id: "LATER", value: "Later Redeemed" },
    { id: "STAFF", value: "Staff" },
    { id: "BLOCKED", value: "Blocked" },
    { id: "SUSPENDED", value: "Suspended" },
    { id: "MILESTONE", value: "Milestone" },
    { id: "POSTPAID", value: "Postpaid" },
    { id: "TRY_AGAIN", value: "Try Again" },
    { id: "INACTIVE", value: "Inactive" },
  ];
  const channels = [
    { id: "USSD", value: "USSD" },
    { id: "WEB", value: "Web" },
    { id: "MESSENGER", value: "Messenger" },
    { id: "WHATSAPP", value: "WhatsApp" },
  ];

  useEffect(() => {
    fetchCampaignRewards();
    fetchStations();
  }, []);

  const fetchCampaignRewards = async () => {
    try {
      const { data } = await restService.Configs.getRewardPackages(
        campaign?.id
      );

      setRewards(data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchStations = async () => {
    try {
      const {
        data: { code, data },
      } = await restService.Management.getStations(campaign.id);

      setStations(data);
    } catch (error) {
      console.log(error);
    }
  };

  const showActionMenu = (id) => {
    // toggle classlist of id
    document.getElementById(id).classList.toggle("hidden");
    setActionMenu(id);
  };

  return (
    <div className="bg-white py-5 sticky top-[80px] px-3 rounded shadow">
      <div className="   bg-white  ">
        <div className="flex bg-white items-center justify-between ">
          <div className="flex items-center">
            <div>
              <div className="">
                <label className="relative block">
                  <span className="sr-only">Search</span>
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.21879 9.21873L6.64941 6.64935"
                        stroke="#848484"
                        strokeMiterlimit="10"
                        strokeMiterLimit="square"
                      />
                      <path
                        d="M4.21875 7.65625C6.11723 7.65625 7.65625 6.11723 7.65625 4.21875C7.65625 2.32027 6.11723 0.78125 4.21875 0.78125C2.32027 0.78125 0.78125 2.32027 0.78125 4.21875C0.78125 6.11723 2.32027 7.65625 4.21875 7.65625Z"
                        stroke="#848484"
                        strokeMiterlimit="10"
                        strokeMiterLimit="square"
                      />
                    </svg>
                  </span>
                  <input
                    type="text"
                    placeholder="Search for code or phone number"
                    onChange={(e) => {
                      setPage(0);
                      handleSearch(e.target.value);
                    }}
                    className="py-1.5 pl-8 border-none focus:border-none focus:pr-10 focus:outline-none rounded-md bg-[#F4F4F4] "
                  />
                </label>
              </div>
            </div>
          </div>

          {user?.role !== "customer-support" && (
            <ExportReportButton
              user={user}
              handleExport={async (recipient) => await exportEntries(recipient)}
            />
          )}
        </div>
      </div>

      {/*filter*/}
      <div className="bg-white w-full ">
        <div className="flex flex-wrap lg:items-center   mt-4 w-full ">
          {/*period*/}

          <div className="relative inline-block mr-2">
            <div className="flex">
              <DatePicker
                emptyState={"Entries Period"}
                state={transactionsFilters?.dateRange}
                setState={(data) => {
                  updateTransactionFilters("dateRange", data);
                }}
              />

              {(dateRange[0].endDate || dateRange[0].startDate) && (
                <button
                  className="flex items-center justify-between mx-0 px-0"
                  onClick={(e) => {
                    updateTransactionFilters("dateRange", [
                      {
                        startDate: "",
                        endDate: "",
                        key: "selection",
                      },
                    ]);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 "
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="red"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>

          {/*stations*/}

          <div className=" flex-shrink-0 inline-block mr-2">
            <div className="flex">
              <Dropdown title={station ? station : "Station"}>
                <div className="w-full">
                  {stations?.map((value, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        setPage(0);
                        updateTransactionFilters("station", value.location);
                        setActionMenu("");
                      }}
                      className="flex align-center py-2 text-[#848484] text-sm hover:bg-[#F4F4F4] hover:rounded-lg focus:bg-[#F4F4F4] focus:rounded-lg  px-4 w-full"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mr-4"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M5 3a1 1 0 000 2c5.523 0 10 4.477 10 10a1 1 0 102 0C17 8.373 11.627 3 5 3z" />
                        <path d="M4 9a1 1 0 011-1 7 7 0 017 7 1 1 0 11-2 0 5 5 0 00-5-5 1 1 0 01-1-1zM3 15a2 2 0 114 0 2 2 0 01-4 0z" />
                      </svg>
                      {value.location}
                    </button>
                  ))}
                </div>
              </Dropdown>

              {station && (
                <button
                  className="flex items-center justify-between mx-0 px-0"
                  onClick={(e) => {
                    setPage(0);
                    updateTransactionFilters("station", "");
                    setActionMenu("");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="red"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>

          {/*phone*/}
          <div className="relative inline-block mr-2">
            <div className="flex items-center">
              <button
                className="border hover:bg-[#F4F4F4] text-sm border-gray-400 whitespace-nowrap	rounded py-1.5 px-3"
                id="menu-button"
                aria-expanded="true"
                onClick={() => showActionMenu("phoneNumberMenu")}
                aria-haspopup="true"
              >
                {msisdn ? msisdn : "Phone Number"}
              </button>
              {msisdn && (
                <button
                  className="flex items-center justify-between mx-0 px-0"
                  onClick={(e) => {
                    setMsisdn("");
                    setActionMenu("");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 "
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="red"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </button>
              )}
            </div>
            <div
              id="phoneNumberMenu"
              className={`absolute ${
                actionMenu !== "phoneNumberMenu" && "hidden"
              }  origin-top-left  mt-2 ring-1 ring-black ring-opacity-5 focus:outline-none left-0 z-10 shadow-xl w-50 bg-white rounded-lg`}
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="menu-button"
              tabIndex="-1"
            >
              <div className="my-2 px-4 pr-16 py-4 ">
                Phone
                <label htmlFor="phoneNumber" className="relative block">
                  <span className="sr-only">Search</span>

                  <span className="absolute inset-y-0 left-0 flex items-center pl-3 pr-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                  </span>

                  <input
                    value={msisdn}
                    onChange={(e) => {
                      setPage(0);
                      setMsisdn(e.target.value);
                    }}
                    placeholder="Search customer "
                    className="py-1.5 pl-9 pr-3  bg-white ring-1 text-[#848484] ring-gray-400 px-2 focus:outline-none rounded"
                    type="number"
                  />
                </label>
              </div>
            </div>
          </div>

          {/*Status*/}
          <div className="inline-block mr-2">
            <div className="flex items-center">
              <Dropdown
                title={
                  !transactionResult && entryStatus
                    ? entryStatus
                    : transactionResult && entryStatus
                    ? transactionResult
                    : "Status"
                }
              >
                <div className="px-2 w-56">
                  <div>
                    {statuses.map((status) => (
                      <button
                        key={status.id}
                        onClick={() => {
                          setPage(0);
                          updateTransactionFilters("entryStatus", status.id);
                          setTransactionResult("");
                          setActionMenu("");
                        }}
                        className=" flex align-center text-[#848484] capitalize text-sm hover:bg-[#F4F4F4] hover:rounded-lg focus:bg-[#F4F4F4] focus:rounded-lg my-2 px-4 py-1 w-full"
                      >
                        {status?.value?.toLowerCase()?.replaceAll("_", " ")}
                      </button>
                    ))}
                  </div>
                </div>
              </Dropdown>

              {entryStatus && (
                <button
                  className="flex items-center justify-between mx-0 px-0"
                  onClick={(e) => {
                    updateTransactionFilters("entryStatus", "");
                    setPage(0);
                    setTransactionResult("");
                    setActionMenu("");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 "
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="red"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>

          {/*reward*/}
          <div className=" inline-block mr-2">
            <div className="flex items-center">
              <Dropdown title={rewardType || "Reward Type"}>
                <div className="px-2 w-56">
                  {rewards &&
                    rewards?.map((value, index) => (
                      <button
                        key={index}
                        onClick={() => {
                          setPage(0);
                          dispatch(
                            setTransactionFilters({
                              rewardType: value.type,
                              amount:
                                value.type.toLowerCase() === "airtime"
                                  ? value.amount
                                  : "",
                            })
                          );
                          setRewardId(value.rewardId);
                          setActionMenu("");
                        }}
                        className=" flex align-center text-[#848484] text-sm hover:bg-[#F4F4F4] hover:rounded-lg px-4 py-1 w-full"
                      >
                        {handleRewardTypes(
                          value.type.replace("_", " "),
                          value.amount
                        )}

                        {rewardId === value.rewardId && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 ml-auto"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="blue"
                            strokeWidth="2"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        )}
                      </button>
                    ))}
                </div>
              </Dropdown>

              {rewardType && (
                <button
                  className="flex items-center justify-between mx-0 px-0"
                  onClick={(e) => {
                    updateTransactionFilters("rewardType", "");
                    setActionMenu("");
                    setPage(0);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 "
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="red"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>

          {/*networks*/}
          <div
            className="
                 inline-block mr-2"
          >
            <div className="flex items-center">
              <Dropdown
                title={
                  network
                    ? mobileNet[Network.indexOf(network)]
                    : "Mobile Network"
                }
              >
                <div className=" px-2 w-56">
                  {Network?.map((value, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        setPage(0);
                        updateTransactionFilters("network", value);
                        setActionMenu("");
                      }}
                      className=" flex align-center text-[#848484] text-sm hover:bg-[#F4F4F4] hover:rounded-lg focus:bg-[#F4F4F4] focus:rounded-lg my-2 px-4 py-1 w-full"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mr-4"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z"
                          clipRule="evenodd"
                        />
                      </svg>
                      {mobileNet[index]}
                    </button>
                  ))}
                </div>
              </Dropdown>

              {network && (
                <button
                  className="flex items-center justify-between mx-0 px-0"
                  onClick={(e) => {
                    updateTransactionFilters("network", "");
                    setActionMenu("");
                    setPage(0);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 "
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="red"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>

          {/*Channel*/}
          <div className=" inline-block mr-2">
            <div className="flex items-center">
              <Dropdown title={selectedChannel || "Channel"}>
                <div className="px-2 w-56">
                  <div>
                    {channels.map((channel) => (
                      <button
                        key={channel.id}
                        onClick={() => {
                          setPage(0);
                          updateTransactionFilters(
                            "selectedChannel",
                            channel.value
                          );
                          setTransactionResult("");
                          setActionMenu("");
                        }}
                        className=" flex align-center text-[#848484] capitalize text-sm hover:bg-[#F4F4F4] hover:rounded-lg focus:bg-[#F4F4F4] focus:rounded-lg my-2 px-4 py-1 w-full"
                      >
                        {channel?.value}
                      </button>
                    ))}
                  </div>
                </div>
              </Dropdown>

              {selectedChannel && (
                <button
                  className="flex items-center justify-between mx-0 px-0"
                  onClick={(e) => {
                    updateTransactionFilters("selectedChannel", "");
                    setActionMenu("");
                    setPage(0);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 "
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="red"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
